/* DD Sweets: pincode delivery estimate. Express (theme settings): Chennai next day, Tamil Nadu (600–643) 2 days.
   Other zones follow the store's shipping policy:
   Tamil Nadu 1–3, South India 2–4, rest of India 3–7 business days, after 1–2 days processing. */
(() => {
  const ZONES = [
    { name: 'Tamil Nadu', test: (p) => /^6[0-4]/.test(p), min: 1, max: 3 },
    { name: 'South India', test: (p) => /^(5[0-3]|5[6-9]|6[7-9])/.test(p), min: 2, max: 4 },
    { name: 'rest of India', test: () => true, min: 3, max: 7 },
  ];

  // Adds business days, skipping Sundays (orders are not processed on Sundays).
  const addBusinessDays = (date, days) => {
    const d = new Date(date);
    let added = 0;
    while (added < days) {
      d.setDate(d.getDate() + 1);
      if (d.getDay() !== 0) added += 1;
    }
    return d;
  };

  const fmt = (d) => d.toLocaleDateString('en-IN', { weekday: 'short', day: 'numeric', month: 'short' });

  const init = (root) => {
    if (root.dataset.ddReady) return;
    root.dataset.ddReady = '1';
    const form = root.querySelector('[data-dd-pin-form]');
    const input = root.querySelector('[data-dd-pin]');
    const out = root.querySelector('[data-dd-pin-result]');
    const dispatchMin = parseInt(root.dataset.dispatchMin, 10) || 1;
    const dispatchMax = parseInt(root.dataset.dispatchMax, 10) || 2;

    try {
      const saved = localStorage.getItem('dd-pincode');
      if (saved) input.value = saved;
    } catch (e) {}

    input.addEventListener('input', () => { input.value = input.value.replace(/\D/g, '').slice(0, 6); });

    form.addEventListener('submit', (event) => {
      event.preventDefault();
      const pin = input.value.trim();
      out.classList.remove('is-ok', 'is-error');
      if (!/^[1-9][0-9]{5}$/.test(pin)) {
        out.textContent = 'Please enter a valid 6-digit pincode.';
        out.classList.add('is-error');
        return;
      }
      try { localStorage.setItem('dd-pincode', pin); } catch (e) {}
      const now = new Date();
      const ex = root.dataset;
      if (ex.expressCity) {
        const cityPins = (ex.expressCityPins || '600').split(',').map((s) => s.trim()).filter(Boolean);
        const isCity = cityPins.some((p) => pin.startsWith(p));
        const isState = /^6[0-3]\d|^64[0-3]/.test(pin);
        if (isCity || isState) {
          const days = parseInt(isCity ? ex.expressCityDays : ex.expressStateDays, 10) || (isCity ? 1 : 2);
          const label = isCity ? `${days === 1 ? 'Next-day' : days + '-day'} delivery in ${ex.expressCity}` : `${days}-day delivery in ${ex.expressState}`;
          out.textContent = `${label} – arrives by ${fmt(addBusinessDays(now, days))}`;
          out.classList.add('is-ok');
          return;
        }
      }
      const zone = ZONES.find((z) => z.test(pin));
      const from = addBusinessDays(now, dispatchMin + zone.min);
      const to = addBusinessDays(now, dispatchMax + zone.max);
      out.textContent = `Delivers by ${fmt(from)} – ${fmt(to)} (${zone.name})`;
      out.classList.add('is-ok');
    });
  };

  const scan = () => document.querySelectorAll('[data-dd-delivery]').forEach(init);
  document.addEventListener('DOMContentLoaded', scan);
  document.addEventListener('shopify:section:load', scan);
  // Quick view and variant changes re-render product blocks.
  let queued = false;
  new MutationObserver(() => {
    if (queued) return;
    queued = true;
    requestAnimationFrame(() => { queued = false; scan(); });
  }).observe(document.body || document.documentElement, { childList: true, subtree: true });
})();

/* DD Sweets: size dropdown on product cards – switch the card's form variant, price and saving line. */
const ddSelectCardVariant = (select) => {
  const card = select.closest('[data-product-card-wrapper]') || select.closest('.product-card-detail');
  const pill = select.options[select.selectedIndex];
  if (!card || !pill) return;

  const available = pill.dataset.available === 'true';
  const input = card.querySelector('form input[name="id"]');
  if (input) {
    input.value = pill.value;
    input.disabled = !available;
  }
  const button = card.querySelector('form button[type="submit"], form [name="add"]');
  if (button) button.disabled = !available;

  const price = card.querySelector('.product-price');
  if (price) {
    const now = [...price.children].find((el) => el.tagName === 'SPAN' && !el.matches('.visually-hidden, .compare-price, .unit-price'));
    if (now) now.textContent = pill.dataset.price;
    let was = price.querySelector('.compare-price');
    if (pill.dataset.compare) {
      if (!was && now) {
        was = document.createElement('span');
        was.className = 'compare-price text-small';
        now.after(was);
      }
      if (was) { was.textContent = pill.dataset.compare; was.hidden = false; }
      price.classList.add('price--on-sale');
    } else {
      if (was) was.hidden = true;
      price.classList.remove('price--on-sale');
    }
  }

  const save = card.querySelector('[data-dd-card-save]');
  if (save) {
    save.textContent = (pill.dataset.save || '').trim();
    save.hidden = !save.textContent;
  }
};
document.addEventListener('change', (event) => {
  if (event.target.matches('[data-dd-cv-select]')) ddSelectCardVariant(event.target);
});
// Show the pre-selected size's price instead of the theme's "From" price.
const ddInitCardVariants = () => document.querySelectorAll('[data-dd-card-variants]:not([data-dd-ready])').forEach((group) => {
  group.dataset.ddReady = '1';
  const select = group.querySelector('[data-dd-cv-select]');
  if (select) ddSelectCardVariant(select);
});
document.addEventListener('DOMContentLoaded', ddInitCardVariants);
new MutationObserver(() => requestAnimationFrame(ddInitCardVariants)).observe(document.documentElement, { childList: true, subtree: true });
